export interface IAidasProperties {
  id?: number;
  name?: string;
  value?: string;
  systemProperty?: boolean;
  optional?: boolean;
  description?: string | null;
}

export const defaultValue: Readonly<IAidasProperties> = {
  systemProperty: false,
  optional: false,
};
